import collectionReducer from '../collectionReducer';

export default collectionReducer({
    collectionActionName: 'COMPANY_APM_GROUPS',
    itemActionName: 'COMPANY_APM_GROUP',
});
